import { radiusCva, Spinner, Text, useProvider } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { toastCva } from "./cva"

interface LoadingIndicatorToastProps {
	description?: string
}

export const LoadingIndicatorToast = memo<LoadingIndicatorToastProps>((props) => {
	const { description } = props
	const { radius } = useProvider()

	return (
		<div className={cx(radiusCva({ radius, maxLarge: true }), toastCva(), "flex items-center gap-2 p-2")}>
			<Spinner size="xs" />
			<Text size="xs" accentColor="base">
				{description}
			</Text>
		</div>
	)
})
LoadingIndicatorToast.displayName = "LoadingIndicatorToast"
